module.exports = __webpack_public_path__ + "static/media/02.53e593f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/02.jpg
// module id = 371
// module chunks = 0